export default "__VITE_ASSET__CTl8Zo2D__"